import type { SVGProps } from 'react';

const SvgEditLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M13 6.00009L18 11.0001M4 19.0001V15.4143C4 15.1491 4.10536 14.8947 4.29289 14.7072L15.2929 3.7072C15.6834 3.31668 16.3166 3.31668 16.7071 3.7072L20.2929 7.29299C20.6834 7.68351 20.6834 8.31668 20.2929 8.7072L9.29289 19.7072C9.10536 19.8947 8.851 20.0001 8.58579 20.0001H5C4.44772 20.0001 4 19.5524 4 19.0001Z'
      stroke='currentColor'
    />
  </svg>
);
export default SvgEditLt;
